import { ReactNode } from 'react';
import Header from '../elements/Header/Header';
import Footer from '../elements/footer/Footer';
import { OrganizationSchema } from '@/components/main/seo/OrganizationSchema';


export default async function MainLayout({
    children,
}: Readonly<{
    children: ReactNode;
}>) {
    return (
        <>
            <OrganizationSchema /> {/* ✅ Invisible - only for search engines to improve seo - because of the <script type="application/ld+json"> tag in the file */}
            <Header />
            <main className="flex flex-col">
                <div className="min-h-full">{children}</div>
                <Footer />
            </main>
        </>
    );
}
